import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { select, Store } from '@ngrx/store';
import { ProductRequest } from '../../../models/ProductRequest';
import { AppState } from '../../../state/reducers';
import {
  AddProductRequestCommentSuccess,
  HandleProductRequestUpdate,
  OpenProductRequestDetail
} from '../../state/actions';
import {WebsocketService} from '../../../conversation/websocket.service';
import {getCurrentPractice} from '../../../practices/state/selectors';
import {takeWhile} from 'rxjs/operators';
import {Practice} from '../../../models/Practice';
import {Subscription} from 'rxjs';
import {ProductRequestAdapter} from '../../../adapters/product-request.adapter';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { TitleService } from '../../../services/title.service';

@Component({
  selector: 'page-product-requests-board',
  templateUrl: './product-requests-board.component.html',
  styleUrls: ['./product-requests-board.component.scss']
})
export class ProductRequestsBoardPage implements OnInit, OnDestroy {
  alive = true;
  currentPractice: Practice | null = null;
  websocketConnected = false;
  socketUpdates$?: Subscription;
  openId: number | null = null;

  constructor(
    private store: Store<AppState>,
    private customTitleService: TitleService,
    private titleService: Title,
    private websocketService: WebsocketService,
    private productRequestAdapter: ProductRequestAdapter,
    private gaService: GoogleAnalyticsService,
  ) {
    this.customTitleService.setTranslatedTitle('product_requests.board_page.title');
  }

  ngOnInit(): void {
    this.subscribeToCurrentPractice();

    this.websocketService.onConnect$.subscribe(connected => {
      this.websocketConnected = connected;
      this.joinRoom();
    });

    this.socketUpdates$ = this.websocketService.getProductRequestListUpdates().subscribe((data) => {
      this.store.dispatch(HandleProductRequestUpdate({productRequest: this.productRequestAdapter.run(data)}));
    });

    this.gaService.pageView(this.titleService.getTitle());
  }

  ngOnDestroy(): void {
    this.alive = false;

    this.socketUpdates$?.unsubscribe();

    if (this.currentPractice) {
      this.websocketService.leaveProductRequestList(this.currentPractice.id.toString());
    }
  }

  subscribeToCurrentPractice(): void {
    this.store.pipe(select(getCurrentPractice))
      .pipe(takeWhile(() => this.alive))
      .subscribe((practice) => {
        if (this.currentPractice) {
          this.websocketService.leaveProductRequestList(this.currentPractice.id.toString());
        }

        this.currentPractice = practice;
        this.joinRoom();
      });
  }

  joinRoom(): void {
    if (this.websocketConnected && this.currentPractice) {
      this.websocketService.joinProductRequestList(this.currentPractice.id.toString());
    }
  }
}
